import { render, staticRenderFns } from "./ContentTypeExtendedCards.vue?vue&type=template&id=fead0d02&scoped=true&"
import script from "./ContentTypeExtendedCards.vue?vue&type=script&lang=js&"
export * from "./ContentTypeExtendedCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead0d02",
  null
  
)

export default component.exports